import React, {useContext, useState} from "react";
import UserContext from "../../../../contexts/UserContext";
import {SocketContext} from "../../../../contexts/SocketContext";
import IOnGetOpenOrdersWithPartialShipmentsReportDTO
    from "../../../../models/DTO/IOnGetOpenOrdersWithPartialShipmentsReportDTO";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import IProcessed_Report from "../../../../models/IProcessed_Report";
import { Link } from "react-router";
import OwTable from "../../../shared/OwTable/OwTable";
import SupplierContext from "../../../../contexts/SupplierContext";
import IOwTableCols from "../../../../models/IOwTableCols";
import IOpenOrdersPartialShipmentOrderItem from "../../../../models/IOpenOrdersPartialShipmentOrderItem";
import * as _ from "lodash-es";
import UserService from "../../../../services/UserService";
import ExcelJS from "exceljs";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwButton from "../../../shared/OwButton/OwButton";

type Props = {
    processedReport: IProcessed_Report;
};

export const OpenOrdersWithPartialShipmentsReport = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const uiContext = useContext(UserContext);
    const socket = useContext(SocketContext)!;

    const [reportData, setReportData] = useState<IOnGetOpenOrdersWithPartialShipmentsReportDTO | undefined>(props.processedReport.report_data);

    const renderQtyShipped = (row: IOpenOrdersPartialShipmentOrderItem) => {
        return row.qtyShipped ? row.qtyShipped : 0;
    };

    const orderItemColumns: IOwTableCols[] = [
        {
            title: "item",
            valueProp: "orderItemNo",
            className: "w-5r",
        },
        {
            title: "name",
            valueProp: "catalogItemName",
            className: "w-10r",
        },
        {
            title: "sku",
            valueProp: "catalogItemSku",
            className: "w-10r",
        },
        {
            title: "qty",
            valueProp: "qty",
            className: "w-10r",
        },
        {
            title: "qty_shipped",
            valueProp: "qtyShipped",
            renderFn: renderQtyShipped,
            renderFnEmitsRow: true,
            className: "w-10r",
        },
    ];

    const sortData = (dataSet: IOpenOrdersPartialShipmentOrderItem[]): IOpenOrdersPartialShipmentOrderItem[] => {
        const sortedArray = dataSet.sort((a, b) => {
            const aStr = String(a.orderItemNo);
            const bStr = String(b.orderItemNo);

            const aParts = aStr.split('.');
            const bParts = bStr.split('.');

            const aInt = parseInt(aParts[0], 10);
            const bInt = parseInt(bParts[0], 10);

            if (aInt !== bInt) {
                return aInt - bInt; // Sort by integer part
            }

            // If integer parts are equal, compare fractional parts
            const aFrac = aParts.length > 1 ? parseFloat(`0.${aParts[1]}`) : 0;
            const bFrac = bParts.length > 1 ? parseFloat(`0.${bParts[1]}`) : 0;

            return aFrac - bFrac;
        });
        return sortedArray;
    };

    const downloadExcel = () => {
        if (reportData) {
            const workbook = new ExcelJS.Workbook();

            for (const order of reportData.orders) {
                const existingWorksheet = workbook.getWorksheet(order.orderName);

                if (!existingWorksheet) {
                    const ws = workbook.addWorksheet(`${order.orderName}`);

                    ws.columns = [
                        { header: "Order", key: "order_name" },
                        { header: "No", key: "item_no" },
                        { header: "Name", key: "name" },
                        { header: "SKU", key: "sku" },
                        { header: "Qty.", key: "qty" },
                        { header: "Qty. Shipped", key: "qty_shipped" },
                    ];

                    const headerCells = ["A1", "B1", "C1", "D1", "E1", "F1"];

                    for (const header of headerCells) {
                        ws.getCell(header).font = {
                            bold: true,
                        };
                    }

                    for (const orderItem of order.orderItems) {
                        ws.addRow({
                            order_name: order.orderName,
                            item_no: orderItem.orderItemNo,
                            name: orderItem.catalogItemName,
                            sku: orderItem.catalogItemSku,
                            qty: orderItem.qty,
                            qty_shipped: orderItem.qtyShipped,
                        });
                    }
                } else {
                    // show the user an error message...
                }

            }

            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement("a");
                anchor.href = url;
                anchor.download = `Orderwerks Open Orders With Partial Shipments Report.xlsx`;
                anchor.click();
                window.URL.revokeObjectURL(url);
            });
        }
    };

    return <div className={"OpenOrdersWithPartialShipmentsReport"}>
        <OwTitle title={"open_orders_with_partial_shipments"} tag={"h3"} />
        {reportData ? <OwButton className={"d-print-none btn-primary"} title={"excel"} fn={downloadExcel} leftIconClass={"fas fa-download"} /> : null}
        <div className="mt-3">
            {
                reportData?.orders.map((order) => {
                    return <div key={order.orderGuid} className={"mb-5"}>
                        <Link to={`/orders/${order.orderGuid}/entry`}>{order.orderName}</Link>
                        <OwTable
                            rowKeyProp={'orderItemGuid'}
                            columns={orderItemColumns}
                            dataSet={sortData(order.orderItems)}
                            userModel={userModel}
                            supplierModel={supplierModel}
                            dataFetch={false}
                            initialData={false}
                        />
                    </div>
                })
            }
        </div>
    </div>;
};
